import { LauncherElement } from '../../types/launcherElement';
import { addElement } from './addElement';
import { getElementById } from './getElementById';
import { removeElement } from './removeElement';

export const moveElement = (
  elements: LauncherElement[],
  elementId: string,
  targetId: string | null,
  index: number
) => {
  const [element] = getElementById(elements, elementId);
  if (!element) return null;

  const [newArr1] = removeElement(elements, elementId);

  let [newArr2, newElement] = addElement({
    elements: newArr1,
    elementType: element.type,
    targetId,
    index,
  });
  newElement = Object.assign(newElement!, element);

  if (targetId) {
    newElement.props.class = {
      ...newElement.props.class,
      position: 'relative',
      top: undefined,
      left: undefined,
    };
  } else {
    newElement.props.class = {
      ...newElement.props.class,
      position: 'absolute',
      top: 0,
      left: 0,
    };
  }

  return [...newArr2];
};
